function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

/** Returns true only for a backend-persisted instruction to withhold a metric. */
export function isMetricSuppressed(data, metric) {
  const outcomes = data?.results?.processingOutcomes;
  if (!isObject(outcomes)) return false;

  return Object.values(outcomes).some((outcome) => {
    if (!isObject(outcome)) return false;
    const metricState = outcome?.metricStates?.[metric];
    if (isObject(metricState) && metricState.presentation === "suppressed") {
      return true;
    }
    return (
      outcome.status === "failed" &&
      Array.isArray(outcome.affectedMetrics) &&
      outcome.affectedMetrics.includes(metric)
    );
  });
}
